import { createI18n } from "vue-i18n";
import getLocale from "../locale";

import en from "@/locales/en.json";
import de from "@/locales/de.json";

const locale_config = getLocale();

export const i18n = createI18n({
  legacy: false,
  locale: locale_config,
  fallbackLocale: locale_config,
  messages: {
    en,
    de,
  },
});
